var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-view c:col-center",style:({
    '--tabbar-height': _vm.computedTabHeight,
    '--tabbar-padding-x': _vm.computedTabPaddingX,
    '--tabbar-text-color': _vm.tabbarTextColor,
    '--tabbar-rail-color': _vm.tabbarRailColor,
    '--tabs-count': _vm.tabs.length || 1,
    '--active-index': _vm.activeIndex,
  })},[_c('div',{staticClass:"tabbar c:row-center"},[_vm._l((_vm.tabs),function(tab,index){return _c('div',{key:tab.key,staticClass:"tab-item c:row-center",class:{ active: tab.key === _vm.activeKey },on:{"click":function($event){return _vm.throttledOnTabClick(tab, index)}}},[_vm._v("\n      "+_vm._s(tab.label)+"\n    ")])}),_vm._m(0)],2),_c('div',{staticClass:"active-view"},[_c('keep-alive',[(_vm.hasSlot)?_vm._t(_vm.activeKey):_vm._e()],2)],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"active-bar-rail"},[_c('div',{staticClass:"active-bar"},[_c('div',{staticClass:"active-bar-highlight"})])])
}]

export { render, staticRenderFns }